export const SEATING_PLAN_DESIGNER_MIN_WIDTH = 1100;
export const SEATING_PLAN_DESIGNER_MIN_HEIGHT = 700;

export type SeatingPlanDesignerBlockReason = 'touch' | 'size';

export interface SeatingPlanDesignerViewport {
  width: number;
  height: number;
}
